import type { RouteConfig } from 'react-router-config'
import { Shopping } from '@yy/one-icon'
import { withAsync } from '@/components/Async'
import { withAuthRedirect } from '@/components/Authorized/hoc/withAuthRedirect'
import Blank from '@/layouts/Blank'

const routes: RouteConfig[] = [
  // 快速建单
  {
    alias: 'quick_sale',
    path: '/selling',
    component: withAuthRedirect(Blank, { first: '/selling/link' }),
    menuTitle: 'selling.title',
    icon: Shopping,
    permissionCode: 'sellToOrder:link,sellToOrder:config',
    routes: [
      // 链接管理
      {
        alias: 'url_management',
        path: '/link',
        permissionCode: 'sellToOrder:link',
        component: withAsync(() => import(/* webpackChunkName: "SellingLink" */ '@/containers/Selling/Link')),
        menuTitle: 'selling.link.title',
        exact: true,
      },
      // 创建链接
      {
        path: '/link/create',
        component: withAsync(() => import(/* webpackChunkName: "CreateOrEdit" */ '@/containers/Selling/CreateOrEdit')),
        hideMenu: true,
        exact: true,
      },
      // 编辑链接
      {
        path: '/link/edit/:id',
        component: withAsync(() => import(/* webpackChunkName: "CreateOrEdit" */ '@/containers/Selling/CreateOrEdit')),
        hideMenu: true,
        exact: true,
      },
      // 销售设置
      {
        alias: 'selling_settings',
        path: '/setting',
        permissionCode: 'sellToOrder:config',
        component: withAsync(() => import(/* webpackChunkName: "SellingSetting" */ '@/containers/Selling/Setting')),
        menuTitle: 'selling.setting.title',
        exact: true,
      },
      // 销售设置隐私协议预览页面
      {
        path: '/privacyPreview',
        component: withAsync(() => import(/* webpackChunkName: "SellingSetting" */ '@/containers/Selling/PrivacyPreview')),
        exact: true,
      },
    ],
  },
]

export default routes
